import React, { useState, useEffect, useContext } from 'react'
import styled from 'styled-components'
import '../../../styleLess/signature/Taskdetail.scss'
import { getGoogleAddress } from '../../../api/Google/googlemaps'
import { Progress, Row, Button, Col } from 'antd'

import {
  CloudUploadOutlined,
  EnvironmentOutlined,
  FileTextOutlined,
  PictureOutlined,
  UnorderedListOutlined,
  EyeOutlined,
  DownOutlined,
} from '@ant-design/icons'
import { Checkbox, Modal } from 'antd'
import update from '../../../icons/Taskbox/updatestatus.svg'
import Map, { Marker } from '../../../common/GoogleMap/googlemap.common'
import { locationPOST, checkboxTaskDone } from 'api/TaskInbox/checklist'
import { getCookie } from 'helper/cookie'
import { useParams } from 'react-router-dom'
import ImageComponent from 'common/Upload/Image'
import Document from 'common/Upload/Document'
import loadingAnimationSvg from 'icons/three-dots.svg'
import DeleteFile from 'common/Upload/DeleteFile'
import { getListFileByTaskCheckList } from 'api/TaskInbox/checklist'
import GetURL from 'common/GetURLDocument/getURLCommon'
import { CounterContext } from 'redux/Golbalvalues'
import loadingAnimationthreedot from 'icons/three-dots.svg'
import { set } from 'lodash'

const Container = styled.div``
const DocumentContainer = styled.div``
const TakephotoContainer = styled.div``
const CheckinContainer = styled.div``
const TodolistContainer = styled.div``
const EmptyState = styled.div``

const AreaMapping = styled.div``
const initalState = {
  data: [],
  isLoading: true,
}

const initialState = {
  center: {
    lat: null,
    lng: null,
  },
  googleAddress: {
    address: '',
    name: '',
  },
}
let render = ''
const CheckList = (props) => {
  const {
    useChangStatus,
    statusMap,
    getCheckList,
    getLogList,
    flow_status,
    percent,
    dataCheckList,
    hidden,
  } = props

  if (dataCheckList.length != 0) {
    if (
      !dataCheckList[0].data &&
      !dataCheckList[1].data &&
      !dataCheckList[2].data &&
      !dataCheckList[3].data
    ) {
      render = '0'
    } else {
      render = '1'
    }
  }

  const nowUserPosition = async () => {
    navigator.geolocation.getCurrentPosition(async (position) => {
      setCenter((a) => {
        return {
          ...a,
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        }
      })

      let data = {
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      }
      useChangStatus(true)
      const googleAddress = await getGoogleAddress(data)
      if (googleAddress?.results?.length > 0) {
        await setGoogleAddress({
          address: googleAddress?.results[0].formatted_address,
          name: 'Google Maps',
        })
      }
    })
  }

  const [center, setCenter] = useState(initialState.center)
  const [googleAddress, setGoogleAddress] = useState(initialState.googleAddress)
  const [id, setId] = useState()
  const token = getCookie('access_token_admin')
  const { project_id, subtaskId } = useParams()
  const [waitingForgetLocation, setWaitingForgetlocation] = useState(false)
  const [kind, setKind] = useState()
  const [arrayList, setarrayList] = useState([])
  const [listfile_checkrepeat, setListfile_checkrepeat] = useState(initalState.data)

  //getURL
  const [getURL, setGetURL] = useState(false)
  const [dataGetURL, setDataGetURL] = useState(false)
  const [dataGetURLType, setDataGetURLType] = useState(false)
  const [loadingGetURL, setLoadingGetURL] = useState(false)
  const { mainRoleUser, adminPermission } = useContext(CounterContext)
  const [permissionPage, setPermissionPage] = useState({
    create: false,
    read: false,
    update: false,
    delete: false,
  })

  useEffect(() => {
    if (mainRoleUser == 1) {
      setPermissionPage((prevState) => ({
        ...prevState,
        create: true,
        read: true,
        update: true,
        delete: true,
      }))
    } else {
      adminPermission.map((item) => {
        if (item.menu_id == 5 || item.menu_id == 4) {
          setPermissionPage((prevState) => ({
            ...prevState,
            create: item.create == 'Y' ? true : false,
            read: item.read == 'Y' ? true : false,
            update: item.update == 'Y' ? true : false,
            delete: item.delete == 'Y' ? true : false,
          }))
        }
      })
    }
  }, [adminPermission])
  const checkRequired = (required) => {
    if (required === 'Y') {
      return <>* Required</>
    } else {
      return ''
    }
  }
  const [iconVisible, SeticonVisible] = useState(true)
  function onChange(e, id) {
    let check = ''
    if (!e.target.checked) {
      check = 'N'
    } else {
      check = 'Y'
    }
    const data = {
      id: id,
      project_id: parseInt(project_id),
      sprintflow_id: parseInt(subtaskId),
      done: check,
    }
    try {
      checkboxTaskDone({
        params: data,
        token: token,
      }).then((res) => {
        if (res.status === 200) {
          getCheckList()
          getLogList()
        }
      })
    } catch (error) {
      console.log(error)
    }
  }
  const checkboxList = (data) => {
    if (data.done === 'Y') {
      return <Checkbox checked disabled onChange={(e) => onChange(e, data.id)}></Checkbox>
    } else {
      return (
        <Checkbox
          disabled
          checked={false}
          onChange={(e) => onChange(e, data.id)}
        ></Checkbox>
      )
    }
  }
  const checkDone = (item) => {
    let done = false
    if (hidden) {
      done = true
    } else {
      done = false
    }
    if (item.done === 'Y') {
      return (
        <Checkbox
          disabled={done}
          defaultChecked={true}
          onChange={(e) => onChange(e, item.id)}
        ></Checkbox>
      )
    } else {
      return (
        <Checkbox
          defaultChecked={false}
          disabled={done}
          onChange={(e) => onChange(e, item.id)}
        ></Checkbox>
      )
    }
  }
  const color = {
    percent_0: '#19D895',
    percent_50: '#FF6258',
    percent_75: '#FFAF00',
    percent_100: '#19D895',
  }

  //zone modal function  ==> Location Document Srs
  const [documentSrsModal, setdocumentSrsModal] = useState(false)
  const showdocumentSrs = (id) => {
    setId(id)
    setdocumentSrsModal(true)
  }
  const getListFileUploaded = (id) => {
    setListfile_checkrepeat([])
    const data = {
      project_id: project_id,
      sprintflow_id: subtaskId,
      task_id: id,
    }
    try {
      getListFileByTaskCheckList({
        params: data,
        token: token,
      }).then((res) => {
        if (res.status === 200) {
          setListfile_checkrepeat(res.data)
        }
        // console.log(res)
      })
    } catch (error) {
      console.log(error)
    }
  }

  //zone modal function  ==> Location Location Srs
  //--------------------------------------------------
  //zone modal function  ==> Location Location Photo
  const [photoLocationModal, setphotoLocationModal] = useState(false)
  const showphotoLocation = (id) => {
    setId(id)
    setphotoLocationModal(true)
  }
  const canclephotoLocation = () => {
    setphotoLocationModal(false)
  }
  //zone modal function  ==> Location Location Photo
  //--------------------------------------------------
  //zone modal function  ==> Location Google maps

  const [googleMapsModal, setgoogleMapsModal] = useState(false)
  const [newLocation, setNewLocation] = useState(false)
  const showGooglemaps = async (item) => {
    setId(item.id)
    await setCenter((a) => {
      return {
        ...a,
        lat: undefined,
        lng: undefined,
      }
    })
    await setGoogleAddress({
      address: undefined,
      name: 'Google Maps',
    })
    if (item.lat !== undefined || item.long !== undefined) {
      await setCenter((a) => {
        return {
          ...a,
          lat: item.lat,
          lng: item.long,
        }
      })
      setGoogleAddress((t) => {
        return {
          ...t,
          address: item.place,
          name: '',
        }
      })
    } else {
      await nowUserPosition()
    }
    setgoogleMapsModal(true)
  }
  const okGooglemaps = () => {
    const overWriteDatatoGopostAPI = {
      project_id: parseInt(project_id),
      sprintflow_id: parseInt(subtaskId),
      task_id: parseInt(id),
      place: googleAddress.address,
      lat: center.lat,
      long: center.lng,
    }
    try {
      locationPOST({
        params: overWriteDatatoGopostAPI,
        token: token,
      }).then((res) => {
        if (res.status === 200) {
          getCheckList()
          getLogList()
        }
        console.log(res)
      })
    } catch (error) {
      console.log(error)
    }
    setgoogleMapsModal(false)
  }
  const cancleGooglemaps = async () => {
    setgoogleMapsModal(false)
  }

  const handleGoogleAddress = async ({ lat, lng }) => {
    let data = {
      lat: lat ? lat : null,
      lng: lng ? lng : null,
    }
    useChangStatus(true)
    const googleAddress = await getGoogleAddress(data)
    if (googleAddress?.results?.length > 0) {
      await setGoogleAddress({
        address: googleAddress?.results[0].formatted_address,
        name: 'Google Maps',
      })
    }
  }

  const onSetCenter = async ({ x, y, lat, latitude, lng, event, status }) => {
    useChangStatus(true)
    await handleGoogleAddress({ lat, lng })
    await setCenter({
      lat,
      lng,
      status: true,
    })

    setWaitingForgetlocation(false)
  }
  const onPlacesChanged = ({ places }) => {
    places?.forEach(async (place) => {
      if (!place.geometry) {
      }
      if (place.geometry.viewport) {
        const { location } = place.geometry

        const center = { lat: location.lat(), lng: location.lng(), status: statusMap }
        await onSetCenter(center)
      }
    })
  }
  const [titleDoc, setTitleDoc] = useState('')
  const handleClick = (item, type) => {
    if (!hidden) {
      switch (type) {
        case 'doc':
          setTitleDoc(item.title)
          clearListFile()
          getListFileUploaded(item.id)
          return showdocumentSrs(item.id)
        case 'photo':
          setTitleDoc(item.title)
          getListFileUploaded(item.id)
          clearListFile()
          return showphotoLocation(item.id)
        default:
          break
      }
    }
    switch (type) {
      case 'map':
        return showGooglemaps(item)
      default:
        break
    }
  }

  var dataFile = []
  const [iconRB, seticonRB] = useState(false)
  const [visibleDelete, setVisibleDelete] = useState(false)
  const [idFile, setIdFile] = useState()
  const [dataListFile, setDataListFile] = useState(initalState.data)

  const [lastFileDelete, setLastFileDelete] = useState(false)
  const [taskBoxId, setTaskboxId] = useState()
  const clearListFile = () => {
    setDataListFile(initalState.data)
    seticonRB(false)
    setarrayList([])
  }
  const handleshowCollapes = (item) => {
    let newData = selectDataDelete.filter((val) => val.task_id !== item.id)
    setSelectDataDelete(newData)
    WriteId(item.id)
  }
  const WriteId = (id) => {
    setarrayList([
      ...arrayList,
      {
        id: id,
      },
    ])
    ShowandHidden(id)
  }
  const ShowandHidden = (id) => {
    var addData = 0
    for (var i = 0; i < arrayList.length; i++) {
      if (arrayList[i].id == id) {
        addData = id
      }
    }
    if (addData == id) {
      handleRemove(id)
    } else {
      const data = {
        project_id: project_id,
        sprintflow_id: subtaskId,
        task_id: id,
      }
      try {
        getListFileByTaskCheckList({
          params: data,
          token: token,
        }).then((res) => {
          if (res.status === 200) {
            dataFile[id] = res.data
            if (dataListFile.length === 0) {
              setDataListFile((prev) => [...prev, dataFile])
            } else {
              let checkRepeat = false
              dataListFile.map((item) => {
                if (item.length - 1 === id) {
                  checkRepeat = true
                }
              })
              if (checkRepeat === false) {
                setDataListFile((prev) => [...prev, dataFile])
              }
            }
          }
        })
      } catch (error) {
        console.log(error)
      }
      seticonRB(true)
    }
  }
  const handleRemove = (id) => {
    const newTag = arrayList.filter((item) => item.id !== id)
    setarrayList(newTag)
  }
  const showTextViewFile = (data) => {
    if (data.done === 'Y') {
      return <span className="small ">view file uploaded</span>
    } else {
      return <span className="small "> file upload</span>
    }
  }
  const eventIcons = (data) => {
    let Focus = 0
    for (var i = 0; i < arrayList.length; i++) {
      if (arrayList[i].id == data.id) {
        Focus = data.id
      }
    }
    if (data.done === 'Y') {
      return (
        <DownOutlined
          className={iconRB && Focus ? 'downOutlined' : 'active-downOutlined'}
          onClick={() => handleshowCollapes(data)}
        />
      )
    }
  }
  const [checkDelete, setCheckDelete] = useState(false)

  const deleteDataListFile = () => {
    selectDataDelete.map((results) => {
      dataListFile.map((item) => {
        if (item.length - 1 === dataBox.id) {
          item.map((item2) => {
            item2.map((item3, index) => {
              if (item3.id === results.id) {
                item2.splice(index, 1)
              }
            })
          })
        }
      })
    })
    setDataListFile(initalState.data)
    seticonRB(false)
    setarrayList([])
    let newData = selectDataDelete.filter((val) => val.task_id !== dataBox.id)
    setSelectDataDelete(newData)
    setCheckDelete(false)
  }
  useEffect(() => {
    if (checkDelete === true) {
      deleteDataListFile()
    }
  }, [checkDelete])

  const [selectDataDelete, setSelectDataDelete] = useState([])
  const [eventDelete, setEventDelete] = useState('')
  const [dataBox, setDataBox] = useState([])
  const [titletext, setTitletext] = useState('')
  const [subtitletext, setSubtitletext] = useState(' ')
  const onIndataFile = (values) => {
    let BooleanChecker = values.target.checked
    let data = values.target.value

    if (BooleanChecker === true) {
      setSelectDataDelete((prev) => [...prev, data])
    } else if (BooleanChecker === false) {
      let newData = selectDataDelete.filter((val) => val.id !== data.id)
      setSelectDataDelete(newData)
    }
  }

  const deleteFilefollowEvent = (eventtext, data) => {
    let count_MasterFile = 0
    let WhenwasFile = false
    dataListFile.map((item) => {
      item.map((item2) => {
        item2.map((item3) => {
          if (item3.task_id == data.id) {
            WhenwasFile = true
            count_MasterFile = count_MasterFile + 1
          }
        })
      })
    })
    //ทำไม่ให้ขึ่น Modal
    let count_File = 0
    let checkFileselect = false
    selectDataDelete.map((item) => {
      if (item.task_id === data.id) {
        checkFileselect = true
        count_File = count_File + 1
      }
    })

    if (count_MasterFile == count_File) {
      setLastFileDelete(true)
    } else {
      setLastFileDelete(false)
    }

    if (eventtext === 'customfile') {
      setEventDelete('customfile')
      setDataBox(data)
      if (checkFileselect === true) {
        setVisibleDelete(true)
      }
      setTitletext(`Delete this ${count_File} ${count_File > 1 ? 'files' : 'file'} ?`)
      setSubtitletext(
        `Are you sure you want to delete this ${count_File} ${count_File > 1 ? 'files' : 'file'
        } ?`,
      )
    } else if (eventtext === 'allfile') {
      setEventDelete('allfile')
      setDataBox(data)
      if (WhenwasFile === true) {
        setVisibleDelete(true)
      }
      setLastFileDelete(true)
      setTitletext('Delete All ?')
      setSubtitletext('Are you sure you want to delete all file ?')
    }
    setCheckDelete(false)
  }

  const listFile = (data) => {
    if (data !== undefined) {
      return dataListFile.map((item) => {
        if (data.id !== undefined) {
          return item[data.id]?.map((item2) => {
            let typeFile = item2.filename.split('.')

            return (
              <div className="show-file">
                <Row
                  style={{ display: 'flex', alignItems: 'center', flexWrap: 'nowrap' }}
                >
                  <Checkbox
                    value={item2}
                    style={!hidden ? { display: 'flex' } : { display: 'none' }}
                    onChange={onIndataFile}
                  />
                  {typeIconsFile(typeFile[typeFile.length - 1])}
                  <div style={{ display: 'grid' }}>
                    <p className="small cutter-text-line-1">{item2.filename}</p>
                  </div>
                </Row>
                <Row style={{ minWidth: 26 }}>
                  {previewFile(typeFile[typeFile.length - 1], item2)}
                </Row>
              </div>
            )
          })
        }
      })
    }
  }

  const onClickEye = (data, type) => {
    setGetURL(true)
    setDataGetURL(data)
    setDataGetURLType(type)
  }

  const previewFile = (type, file) => {
    if (['jpg', 'jpeg', 'png', 'JPG', 'JPEG', 'PNG'].includes(type)) {
      return (
        <div>
          {loadingGetURL == true ? (
            <img style={{ width: 24, height: 12 }} src={loadingAnimationthreedot}></img>
          ) : (
            <EyeOutlined
              onClick={() => onClickEye(file, 'preview')}
              className="eyeoutlined"
            />
          )}
        </div>
      )
    } else {
      return (
        <div>
          {loadingGetURL == true ? (
            <img style={{ width: 24, height: 12 }} src={loadingAnimationthreedot}></img>
          ) : (
            <EyeOutlined
              onClick={() => onClickEye(file, 'preview')}
              style={{ fontSize: 14 }}
              className="downloadOutlined"
            />
          )}
        </div>
      )
    }
  }
  const typeIconsFile = (type) => {
    if (['jpg', 'jpeg', 'png'].includes(type)) {
      return <PictureOutlined className="fileTextOutlined" />
    } else {
      return <FileTextOutlined className="fileTextOutlined" />
    }
  }
  //zone modal function  ==> Location Google maps
  const RenderItem = (Jaguar) => {
    if (Jaguar.checklist_type_id === 15) {
      if (Jaguar.data !== null) {
        return (
          <DocumentContainer className="DocumentContainer site-drawer-render-in-current-wrapper">
            {Jaguar.data.map((item) => {
              let Focus = 0
              for (var i = 0; i < arrayList.length; i++) {
                if (arrayList[i].id == item.id) {
                  Focus = item.id
                }
              }
              let count_File_select = 0

              return (
                <div id={item.id} className="box-bg">
                  <div className="top">
                    <div hidden={hidden} className="L">
                      {checkboxList(item)}
                    </div>
                    <div className="R">
                      <div style={{ display: 'grid' }}>
                        <p className="cutter-text-line-1">{item.title}</p>
                      </div>
                      <Col>
                        <div className="Editcontent">
                          <div
                            className="responsive-div"
                            onClick={() => handleClick(item, 'doc')}
                            hidden={hidden}
                          >
                            <CloudUploadOutlined className="icon-color" />
                            <span className="small text-hover">click to upload file</span>
                          </div>
                          <span className="small text-required" hidden={hidden}>
                            {checkRequired(item.required)}
                          </span>
                        </div>
                      </Col>
                      <Row className="file-uploaded">
                        {showTextViewFile(item)}
                        {eventIcons(item)}
                      </Row>
                    </div>
                  </div>
                  <div className={Focus ? 'show-collaps bottom' : 'active-show-collaps'}>
                    {Focus !== 0 ? (
                      <div>
                        {listFile(item)}
                        <div className="row-btn-file-event">
                          <Button
                            type="primary"
                            className="btn_Secondary2"
                            hidden={hidden}
                            onClick={() => deleteFilefollowEvent('customfile', item)}
                          >
                            <span className="small">
                              Delete{' '}
                              {selectDataDelete.map((listFiler) => {
                                if (listFiler.task_id == item.id) {
                                  count_File_select = count_File_select + 1
                                }
                              })}
                              {count_File_select}{' '}
                              {count_File_select > 1 ? 'files' : 'file'} Selected
                            </span>
                          </Button>
                          <Button
                            type="primary"
                            className="BTN_Warning"
                            hidden={hidden}
                            onClick={() => deleteFilefollowEvent('allfile', item)}
                          >
                            <span className="small">Delete All</span>
                          </Button>
                        </div>
                      </div>
                    ) : (
                      ''
                    )}
                  </div>
                </div>
              )
            })}
            {/* @@@@@      modal   Document     @@@@@@ */}
            <Document
              visible={documentSrsModal}
              setVisible={setdocumentSrsModal}
              project_id={project_id}
              subtaskId={subtaskId}
              taskId={id}
              kind={15}
              getCheckList={getCheckList}
              getLogList={getLogList}
              titleDoc={titleDoc}
              listFile={listfile_checkrepeat}
            />
          </DocumentContainer>
        )
      }
    } else if (Jaguar.checklist_type_id === 16) {
      if (Jaguar.data !== null) {
        return (
          <TakephotoContainer className="takephotoContainer ">
            {Jaguar.data.map((item) => {
              let Focus = 0
              for (var i = 0; i < arrayList.length; i++) {
                if (arrayList[i].id == item.id) {
                  Focus = item.id
                }
              }
              let count_File_select = 0
              return (
                <div className="box-bg">
                  <div className="top">
                    <div className="L" hidden={hidden}>
                      {checkboxList(item)}
                    </div>
                    <div className="R">
                      <div style={{ display: 'grid' }}>
                        <p className="cutter-text-line-1">{item.title}</p>
                      </div>

                      <div
                        className="Editcontent"
                      >
                        <div
                          className="responsive-div"
                          onClick={() => handleClick(item, 'photo')}
                          hidden={hidden}
                        >
                          <CloudUploadOutlined className="icon-color" />
                          <span className="small text-hover">click to upload file</span>
                        </div>
                        <span className="small text-required" hidden={hidden}>
                          {checkRequired(item.required)}
                        </span>
                      </div>
                      <Row className="file-uploaded">
                        {showTextViewFile(item)}
                        {eventIcons(item)}
                      </Row>
                    </div>
                  </div>
                  <div className={Focus ? 'show-collaps bottom' : 'active-show-collaps'}>
                    {Focus !== 0 ? listFile(item) : ''}
                    <div className="row-btn-file-event">
                      <Button
                        type="primary"
                        className="btn_Secondary2"
                        onClick={() => deleteFilefollowEvent('customfile', item)}
                        hidden={hidden}
                      >
                        <span className="small">
                          Delete{' '}
                          {selectDataDelete.map((listFiler) => {
                            if (listFiler.task_id == item.id) {
                              count_File_select = count_File_select + 1
                            }
                          })}
                          {count_File_select} list Selected
                        </span>
                      </Button>
                      <Button
                        type="primary"
                        className="BTN_Warning"
                        onClick={() => deleteFilefollowEvent('allfile', item)}
                        hidden={hidden}
                      >
                        <span className="small">Delete All</span>
                      </Button>
                    </div>
                  </div>
                </div>
              )
            })}
            {/* @@@@@      modal Photo Location    @@@@@@ */}
            <ImageComponent
              visible={photoLocationModal}
              setVisible={setphotoLocationModal}
              project_id={project_id}
              subtaskId={subtaskId}
              taskId={id}
              getCheckList={getCheckList}
              getLogList={getLogList}
              titleDoc={titleDoc}
              listFile={listfile_checkrepeat}
            />
          </TakephotoContainer>
        )
      }
    } else if (Jaguar.checklist_type_id === 17) {
      if (Jaguar.data !== null) {
        return (
          <CheckinContainer className="CheckinContainer ">
            {Jaguar.data.map((item) => {
              return (
                <div className="box-bg ">
                  <div className="top edit-top">
                    <div className="L" hidden={hidden}>
                      {checkboxList(item)}
                    </div>
                    <div className="R">
                      <div style={{ display: 'grid' }}>
                        <p className="cutter-text-line-1">{item.title}</p>
                      </div>
                      <div style={{ display: 'grid' }}>
                        <span
                          className="small cutter-text-line-multi-2"
                          style={{ marginTop: 4, marginBottom: 4 }}
                        >
                          {item.place}
                        </span>
                      </div>
                      <div
                        className="Editcontent"
                        style={!hidden ? { cursor: 'pointer' } : { cursor: 'unset' }}
                      >
                        <div
                          className="responsive-div"
                          hidden={hidden}
                          style={
                            !hidden
                              ? { cursor: 'pointer' }
                              : { cursor: 'unset !important' }
                          }
                        >
                          <EnvironmentOutlined className="icon-color" />
                          <span
                            onClick={() => handleClick(item, 'map')}
                            className="small"
                          >
                            click to pin location in Google map
                          </span>
                        </div>
                        <span hidden={hidden} className="small text-required">
                          {checkRequired(item.required)}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              )
            })}
            {/* @@@@@      modal  Google maps   @@@@@@ */}

            <Modal
              maskClosable={false}
              className="ChecklistModal"
              title="Check-in Location"
              visible={googleMapsModal}
              okText="Update"
              onOk={okGooglemaps}
              onCancel={cancleGooglemaps}
              okButtonProps={{ hidden: hidden ? true : false }}
              destroyOnClose={true}
            >
              <Map
                className="map"
                center={center}
                onSetCenter={onSetCenter}
                foundLocationnewUser={newLocation}
                status={statusMap}
                restatusFunc={useChangStatus}
                onPlacesChanged={onPlacesChanged}
                loadingGetlocation={setWaitingForgetlocation}
              >
                <Marker lat={center.lat} lng={center.lng} />
              </Map>
              <div
                className={
                  waitingForgetLocation
                    ? 'waite google-maps-loading-container '
                    : 'active-waite'
                }
              >
                <img src={loadingAnimationSvg}></img>
              </div>

              <div className="container-location-tile">
                <span>{googleAddress ? googleAddress?.address : ''}</span>
              </div>
            </Modal>
          </CheckinContainer>
        )
      }
    } else if (Jaguar.checklist_type_id === 18) {
      if (Jaguar.data !== null) {
        return (
          <TodolistContainer className="TodolistContainer">
            {Jaguar.data.map((item) => {
              return (
                <div className="box-bg-longwidth">
                  {checkDone(item)}
                  <div className="R">
                    <div style={{ display: 'grid' }}>
                      <p className="cutter-text-line-1">{item.title}</p>
                    </div>

                    <span className="small text-required">
                      {checkRequired(item.required)}
                    </span>
                  </div>
                </div>
              )
            })}
          </TodolistContainer>
        )
      }
    }
  }
  if (render === '1') {
    return (
      <Container>
        <span
          className={`percent  ${percent < 75 && percent !== 0
            ? 'percent-deley'
            : percent === 100
              ? 'percent-done'
              : percent === 0
                ? 'percent-zero'
                : 'percent-todo'
            }`}
        >
          {percent}%
        </span>
        <Progress
          percent={percent}
          size="small"
          strokeColor={
            percent < 75 && percent !== 0
              ? color.percent_50
              : percent === 100
                ? color.percent_100
                : percent === 0
                  ? color.percent_0
                  : color.percent_75
          }
        />
        <AreaMapping className="AreaMapping">
          {dataCheckList.map((item, index) => {
            if (item.data !== null) {
              return (
                <div className="Checklist-Box">
                  <div className="head">
                    <FileTextOutlined
                      className={
                        iconVisible && index === 0 ? 'iconVisible' : 'activeicon'
                      }
                    />
                    <PictureOutlined
                      className={
                        iconVisible && index === 1 ? 'iconVisible' : 'activeicon'
                      }
                    />
                    <EnvironmentOutlined
                      className={
                        iconVisible && index === 2 ? 'iconVisible' : 'activeicon'
                      }
                    />
                    <UnorderedListOutlined
                      className={
                        iconVisible && index === 3 ? 'iconVisible' : 'activeicon'
                      }
                    />
                    <h4>{item.checklist_type}</h4>
                  </div>

                  {RenderItem(item)}
                </div>
              )
            }
          })}
        </AreaMapping>
        <DeleteFile
          visibleDelete={visibleDelete}
          setVisibleDelete={setVisibleDelete}
          project_id={project_id}
          kind={kind}
          idDelete={idFile}
          clearListFile={clearListFile}
          lastFileDelete={lastFileDelete}
          sprintflow_id={subtaskId}
          taskBoxId={taskBoxId}
          state={'checklist'}
          getCheckList={getCheckList}
          getLogList={getLogList}
          setCheckDelete={setCheckDelete}
          eventDelete={eventDelete}
          dataSelect={selectDataDelete}
          dataBox={dataBox}
          titleText={titletext}
          subtitleText={subtitletext}
          setListfile_checkrepeat={setListfile_checkrepeat}
        />
        <GetURL
          project_id={dataGetURL.project_id}
          id_document={dataGetURL.id}
          type={dataGetURLType}
          setGetURL={setGetURL}
          getURL={getURL}
          setLoadingGetURL={setLoadingGetURL}
          dataFile={dataGetURL}
          state="CheckList"
        />
      </Container>
    )
  } else {
    return (
      <EmptyState className="EmptyStateContainer">
        <img className="img-emptystate big-icons" src={update}></img>
        <h2>Please update your task checklist</h2>
      </EmptyState>
    )
  }
}

export default CheckList
